import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../config/api';

export const fetchWorkshops = createAsyncThunk(
  'workshops/fetchWorkshops',
  async ({ page = 1, limit = 10, contentType, search } = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      if (contentType) params.append('contentType', contentType);
      if (search) params.append('search', search);
      
      const url = `${API_URL}/api/public/workshops?${params}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 
        error.message || 
        'Failed to fetch workshops'
      );
    }
  }
);

export const fetchWorkshopById = createAsyncThunk(
  'workshops/fetchWorkshopById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/api/public/workshops/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch workshop');
    }
  }
);

const workshopsSlice = createSlice({
  name: 'workshops',
  initialState: {
    items: [],
    currentWorkshop: null,
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
    },
    loading: false,
    error: null,
  },
  reducers: {
    setPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    clearCurrentWorkshop: (state) => {
      state.currentWorkshop = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkshops.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkshops.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data || [];
        state.pagination.totalItems = action.payload.total || 0;
        state.pagination.currentPage = action.payload.page || state.pagination.currentPage;
        state.pagination.totalPages = action.payload.totalPages || Math.ceil(
          (action.payload.total || 0) / state.pagination.itemsPerPage
        );
      })
      .addCase(fetchWorkshops.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchWorkshopById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkshopById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentWorkshop = action.payload.data;
      })
      .addCase(fetchWorkshopById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setPage, clearCurrentWorkshop } = workshopsSlice.actions;
export default workshopsSlice.reducer;

